<script setup>
import { ref } from 'vue'
import { useApi } from '../../shared/composables/useApi.js'

const props = defineProps({
  csrfToken:  { type: String, required: true },
  token:      { type: String, default: '' },
  validToken: { type: Boolean, default: false },
  initialError: { type: String, default: '' },
})

const { post } = useApi(props.csrfToken)

const password        = ref('')
const passwordConfirm = ref('')
const error           = ref(props.initialError)
const busy            = ref(false)

async function submit() {
  if (busy.value) return
  error.value = ''
  busy.value = true
  const { ok, data } = await post('/api/auth/reset', {
    token:            props.token,
    password:         password.value,
    password_confirm: passwordConfirm.value,
  })
  if (ok && data.redirect) {
    window.location.href = data.redirect
    return
  }
  error.value = data.error || 'Could not reset password.'
  busy.value = false
}
</script>

<template>
  <div class="auth-card hf-glass">
    <h1>Reset Password</h1>

    <div v-if="error" class="error" role="alert">{{ error }}</div>
    <div v-if="!validToken" class="auth-links">
      <a href="/forgot">Request a new reset link</a>
    </div>

    <form v-if="validToken" novalidate @submit.prevent="submit">
      <div class="form-group">
        <label for="password">New password <span class="field-hint">(minimum 10 characters)</span></label>
        <input
          id="password"
          v-model="password"
          class="hf-input"
          type="password"
          autocomplete="new-password"
          minlength="10"
          required
          autofocus
        />
      </div>
      <div class="form-group">
        <label for="password_confirm">Confirm new password</label>
        <input
          id="password_confirm"
          v-model="passwordConfirm"
          class="hf-input"
          type="password"
          autocomplete="new-password"
          minlength="10"
          required
        />
      </div>
      <button type="submit" class="hf-btn primary auth-submit" :disabled="busy">
        {{ busy ? 'Saving…' : 'Set New Password' }}
      </button>
    </form>

    <div class="auth-links">
      <a href="/login">Back to log in</a>
    </div>
  </div>
</template>
